import { UrlFragments } from 'app/constants';

export enum tabType {
  normal,
  dropDown,
}

export type tabLevel = 'user' | 'subscription';

type ITabKeyItem<T> = {
  [key: string]: {
    type: tabType;
    value: string | T[];
    urlByTab: string;
  };
};

export type ITabKeys<T> = {
  [key in tabLevel]: ITabKeyItem<T>;
};

export type ISubKeys<T, S> = {
  label: T;
  url_path: S;
};

const {
  tabs: { userDetail, portfolios, subscriptionDetail },
} = UrlFragments;

const sharedTabSubKeys: ITabKeyItem<ISubKeys<string, string>> = {
  portfolios: {
    type: tabType.normal,
    value: portfolios,
    urlByTab: portfolios,
  },
};

export const TabKeys: ITabKeys<ISubKeys<string, string>> = {
  user: {
    'user-detail': {
      type: tabType.normal,
      value: userDetail.replace(/-/, ' '),
      urlByTab: userDetail,
    },
    portfolios: sharedTabSubKeys.portfolios,
  },
  subscription: {
    'subscription-details': {
      type: tabType.normal,
      value: subscriptionDetail.replace(/-/, ' '),
      urlByTab: subscriptionDetail,
    },
    portfolios: sharedTabSubKeys.portfolios,
  },
};
